"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var index_1 = __importDefault(require("../Button/index"));
var Icon_1 = require("../Icon");
var index_2 = __importDefault(require("../LocaleProvider/index"));
var index_3 = __importDefault(require("../Row/index"));
var PageButton_1 = __importDefault(require("./PageButton"));
var Pagination = /** @class */ (function (_super) {
    __extends(Pagination, _super);
    function Pagination(props) {
        var _this = _super.call(this, props) || this;
        _this.localeChanged = function () {
            _this.forceUpdate();
        };
        _this.setPage = function (page) {
            if (page !== _this.state.page) {
                _this.setState({
                    page: page,
                }, function () {
                    if (_this.props.onPageChange) {
                        _this.props.onPageChange(page, _this.state.pageSize);
                    }
                });
            }
        };
        _this.changePageSize = function (evt) {
            var pageSize = parseInt(evt.target.value, 10);
            if (pageSize !== _this.state.pageSize) {
                _this.setState({
                    page: 0,
                    pageSize: pageSize,
                }, function () {
                    if (_this.props.onPageChange) {
                        _this.props.onPageChange(0, pageSize);
                    }
                });
            }
        };
        index_2.default.on(_this.localeChanged);
        var defaultPage = 0;
        if (props.defaultPage !== undefined) {
            defaultPage = props.defaultPage;
        }
        else if (props.page !== undefined) {
            defaultPage = props.page;
        }
        var defaultPageSize = Pagination.DEFAULT_PER_PAGE;
        if (props.defaultPageSize !== undefined) {
            defaultPageSize = props.defaultPageSize;
        }
        else if (props.pageSize !== undefined) {
            defaultPageSize = props.pageSize;
        }
        _this.state = {
            page: defaultPage,
            pageSize: defaultPageSize,
        };
        return _this;
    }
    Pagination.getDerivedStateFromProps = function (props, state) {
        var newState = {};
        if (props.page !== undefined && props.page !== state.page) {
            newState.page = props.page;
        }
        if (props.pageSize !== undefined && props.pageSize !== state.pageSize) {
            newState.pageSize = props.pageSize;
        }
        return Object.keys(newState).length === 0 ? null : newState;
    };
    Pagination.prototype.componentWillUnmount = function () {
        index_2.default.off(this.localeChanged);
    };
    // Helper methods to determine if page
    Pagination.prototype.totalPages = function () {
        return Math.ceil((this.props.totalRecords / this.state.pageSize) * 1.0);
    };
    // We have 4 options to render paginations
    // 1 ... total pages is less than BREAKPOINT
    Pagination.prototype.startRange = function () {
        return this.state.page <= Pagination.BREAKPOINT - 2;
    };
    // 2 -> page is in last section
    Pagination.prototype.endRange = function () {
        return this.state.page > this.totalPages() - Pagination.BREAKPOINT;
    };
    // 3 - we dont have enough pages to create pagination...
    // Return array of elements to render!
    Pagination.prototype.pagination = function () {
        var _this = this;
        var ret = [];
        var totalPages = this.totalPages();
        var i = 0;
        var createGap = function (count) { return (react_1.default.createElement("span", { className: "gap", key: "page-gap-" + (count || 1) }, "...")); };
        var createNode = function (targetPage) {
            return (react_1.default.createElement(PageButton_1.default, { page: targetPage, key: "page_" + targetPage, activePage: _this.state.page, onClick: _this.setPage.bind(_this, targetPage) }));
        };
        if (totalPages < Pagination.BREAKPOINT + 6) {
            // Render all pages
            for (i = 0; i < this.totalPages(); i++) {
                ret.push(createNode(i));
            }
        }
        else if (this.startRange()) {
            for (i = 0; i < Pagination.BREAKPOINT; i++) {
                ret.push(createNode(i));
            }
            ret.push(createGap());
            ret.push(createNode(totalPages - 1));
        }
        else if (this.endRange()) {
            // Last pagination section
            ret.push(createNode(0)); // First page
            ret.push(createGap()); // Gap ...
            for (i = totalPages - Pagination.BREAKPOINT; i < totalPages; i++) {
                // Add last-n pages
                ret.push(createNode(i));
            }
        }
        else {
            ret.push(createNode(0)); // First page
            ret.push(createGap()); // Gap ...
            // Add middle-scope 1 ... 5,6,7,8 ... 200
            for (i = this.state.page - 1; i <= this.state.page + 1; i++) {
                ret.push(createNode(i));
            }
            ret.push(createGap(2)); // Gap
            ret.push(createNode(totalPages - 1));
        }
        return ret;
    };
    Pagination.prototype.render = function () {
        var _this = this;
        var _a = this.props, totalRecords = _a.totalRecords, className = _a.className, hidePrevious = _a.hidePrevious, hideNext = _a.hideNext, hidePageSize = _a.hidePageSize, children = _a.children, perPageClassName = _a.perPageClassName;
        var _b = this.state, page = _b.page, pageSize = _b.pageSize;
        var locale = index_2.default.locs.pagination;
        var cn = classnames_1.default("emankit__pagination", "row", "no-gutters", className);
        var totalPages = this.totalPages();
        // tslint:disable:jsx-no-lambda
        var previousButton;
        if (hidePrevious !== true && totalPages > 1) {
            previousButton = (react_1.default.createElement(index_1.default, { onClick: function (_) {
                    _this.setPage(page - 1);
                }, disabled: page === 0, className: "previous_button", icon: Icon_1.IconType.ArrowLeft }));
        }
        var nextButton;
        if (hideNext !== true && totalPages > 1) {
            nextButton = (react_1.default.createElement(index_1.default, { onClick: function (_) {
                    _this.setPage(page + 1);
                }, disabled: page + 1 === totalPages, className: "next_button", icon: Icon_1.IconType.ArrowRight }));
        }
        // tslint:enable:jsx-no-lambda
        var pageSizeCombo;
        var from;
        var to;
        if (!hidePageSize && totalRecords > 0) {
            var options = Pagination.PER_PAGE_OPTIONS.map(function (key) { return (react_1.default.createElement("option", { value: key, key: "page-size-" + key }, key)); });
            from = page * pageSize + 1;
            to = (page + 1) * pageSize;
            if (to > totalRecords) {
                to = totalRecords;
            }
            pageSizeCombo = (react_1.default.createElement("div", { className: "col-6 pages" },
                react_1.default.createElement("div", { className: "select " + (perPageClassName || "") },
                    react_1.default.createElement("select", { defaultValue: "" + pageSize, onChange: this.changePageSize }, options)),
                react_1.default.createElement("span", { className: "label" }, locale.showed),
                children));
        }
        else if (children) {
            pageSizeCombo = react_1.default.createElement("div", { className: "col-6 pages" }, children);
        }
        // tslint:disable: max-line-length
        return (react_1.default.createElement(index_3.default, { pageWidth: false, className: cn },
            pageSizeCombo,
            react_1.default.createElement("div", { className: "col-" + (pageSizeCombo ? 6 : 12) + " buttons" },
                !hidePageSize && from && to ? (react_1.default.createElement("span", { className: "stats" },
                    from,
                    " - ",
                    to,
                    " ",
                    locale.from,
                    " ",
                    totalRecords,
                    " ",
                    this.props.label)) : null,
                previousButton,
                totalPages > 1 && this.pagination(),
                nextButton)));
    };
    // Gap string
    Pagination.GAP_STRING = "...";
    // Default per page records
    Pagination.DEFAULT_PER_PAGE = 20;
    // Per page select options
    Pagination.PER_PAGE_OPTIONS = [10, 20, 50];
    // Max number of pages
    Pagination.BREAKPOINT = 4;
    return Pagination;
}(react_1.Component));
exports.default = Pagination;
//# sourceMappingURL=index.js.map